/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFlagFillRed: {
  name: 'flag-fill-red';
  data: string;
} = {
  name: 'flag-fill-red',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.397 10.794c-.811-.065-1.433.054-1.897.427v3.778a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .146-.354C2.42.872 3.441.714 4.478.798c.977.079 2.063.38 3.12.675l.16.045c1.134.314 2.242.612 3.278.686 1.027.074 1.927-.078 2.673-.61A.5.5 0 0 1 14.5 2v9a.5.5 0 0 1-.21.407c-1.003.717-2.165.878-3.326.795-1.151-.083-2.356-.41-3.473-.72l-.117-.033c-1.096-.305-2.097-.584-2.977-.655Z" fill="currentColor"/></svg>`,
};
